module.exports = __webpack_public_path__ + "static/wyy-4f24bcac2141a3c34792afdac9bedb25.png";